import { GET_GROUP_LIST, GET_USER_LIST, GET_GROUP_UNREAD_MESSAGE_COUNT, GET_MESSAGE_LIST, GET_MAIN_GROUP_USER_LIST, GET_BOOKING_LIST, RESET_REDUX_STATE } from "../constants";

const initState = {
  dataList: [],
  messagesList: [],
  mainGroupUserList: [],
  bookingList: [],
  groupUnreadMessageCount: {},
  totalPages: 0,
  currentPage: 1
};

const chat = (state = initState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_GROUP_LIST: {
      return {
        ...state,
        dataList: payload,
      };
    }
    case GET_USER_LIST: {
      return {
        ...state,
        dataList: payload,
      };
    }
    case GET_GROUP_UNREAD_MESSAGE_COUNT: {
      return {
        ...state,
        groupUnreadMessageCount: payload,
      };
    }
    case GET_MESSAGE_LIST: {
      return {
        ...state,
        messagesList: payload.message,
        totalPages: payload.totalPages,
        currentPage: payload.currentPage
      };
    }
    case GET_MAIN_GROUP_USER_LIST: {
      return {
        ...state,
        mainGroupUserList: payload,
      };
    }
    case GET_BOOKING_LIST: {
      return {
        ...state,
        bookingList: payload,
      };
    }
    case RESET_REDUX_STATE: {
      return initState
    }

    default:
      return state;
  }
};

export default chat;
